import React from 'react'
import WidgetContainer from '../../containers/WidgetContainer'
import ImagesSection from '../../containers/ImagesSection'
import LinksSection from '../../containers/LinksSection'
import ImageBoxWrapper from './ImageBoxWrapper'
import ArticleImageBox from '../../boxes/StyledArticleImageBox'
import { type ArticlesWidgetProps } from './Types'

export default (props: ArticlesWidgetProps) => {
  const {
    activeDynamicLayout,
    isOpening,
    widget,
    widget: {
      ad,
      boxes,
      imageSize = '4_3',
      name,
      utmContent,
      utmMedium,
      utmSource
    },
    renderAdditionalComponent
  } = props

  if (!boxes || !boxes.length) {
    return null
  }

  const textBoxes = [...boxes]
  const headBoxes = textBoxes.splice(0, 2)

  const utmParams = {
    utmContent,
    utmMedium,
    utmSource
  }

  const renderImageBox = (box, index) => <ImageBoxWrapper
    box={box}
    imageBoxComponent={ArticleImageBox}
    imageSize={imageSize}
    index={index}
    key={`articlesBox${index}`}
    utmParams={utmParams}
  />

  return (
    <WidgetContainer widget={widget} isOpening={isOpening}>
      { renderAdditionalComponent && renderAdditionalComponent() }
      {
        headBoxes.length > 0 &&
        <ImagesSection boxes={headBoxes} renderBox={renderImageBox}/>
      }
      {
        textBoxes.length > 0 &&
        <LinksSection ad={ad} boxes={textBoxes} device={activeDynamicLayout} name={name} utmParams={utmParams}/>
      }
    </WidgetContainer>
  )
}
